<template>
    <el-drawer
        v-if="isMobile"
        :append-to-body="true"
        :with-header="false"
        :show-close="false"
        :visible="visible"
        @open="initData"
        @close="onCancel"
        direction="btt"
    >
        <div class="lock-detail stake">
            <template v-if="!isUnlock">
                <route-tab v-if="lockData.token" :tabs="[]">
                    <div @click="tabIndex = 0" :class="['tab-content-item', tabIndex === 0 ? 'active' : '']">{{ $t('page.lockTimeTab') }}</div>
                    <div @click="tabIndex = 1" :class="['tab-content-item', tabIndex === 1 ? 'active' : '']">{{ $t('page.lockValueTab') }}</div>
                </route-tab>
                <div v-if="(lockData.token && tabIndex === 1) || !lockData.token" class="title">{{ $t('page.lockMsg1') }}</div>
                <div v-if="(lockData.token && tabIndex === 1) || !lockData.token" class="amount">
                    <div class="name">{{ $t('page.GyroBalance') }}: {{ $store.state.account.gyro }}Gyro</div>
                    <el-input :disabled="loading" :placeholder="$store.state.account.gyro" v-model="value"></el-input>
                    <el-button class="max mt" @click="value = $store.state.account.gyro">{{ $t('page.max') }}</el-button>
                </div>
                <div v-if="(lockData.token && tabIndex === 0) || !lockData.token" class="title">{{ $t('page.lockMsg2') }}</div>
                <div v-if="(lockData.token && tabIndex === 0) || !lockData.token" class="amount">
                    <div class="name">{{ $t('page.lockMsg3', {m: maxWeek}) }}</div>
                    <el-input-number v-model="week" controls-position="right" :min="0" :max="maxWeek"></el-input-number>
                    <div class="fast-tag">
                        <div
                            :class="['tag', week == tag.week ? 'active' : '']"
                            @click="setWeek(tag.week)"
                            v-for="(tag, index) in fastTags"
                            :key="index"
                        >
                            {{ tag.label }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="info">
                <div class="item">
                    <p class="label">{{ $t('page.voteValue') }}</p>
                    <p class="value">{{ showVeGyro }} veGYRO</p>
                </div>
                <div class="item">
                    <p class="label">{{ $t('page.voteAmount') }}</p>
                    <p class="value">{{ voteAmount }} GYRO</p>
                </div>
                <div class="item">
                    <p class="label">{{ $t('page.expirationDate') }}</p>
                    <p class="value">{{ showExpirationDate }}</p>
                </div>
            </div>
            <div v-if="isUnlock" class="btns">
                <el-button v-if="isReset" :loading="resetLoading" @click="reset" type="primary" class="btn" round>
                    {{ $t('page.reset') }}
                </el-button>
                <el-button :loading="loading" :disabled="unlockStep && isReset" @click="unlock" type="primary" class="btn" round>
                    {{ $t('page.unlock') }}
                </el-button>
            </div>
            <div v-else class="btns">
                <el-button v-if="!isApprove" type="primary" :loading="approveLoading" class="btn approve" @click="setApprove" round>
                    {{ $t('page.approve') }}
                </el-button>
                <el-button :disabled="isAddLock" :loading="loading" @click="confirmLock" type="primary" class="btn" round>
                    {{ confirmLockName }}
                </el-button>
            </div>
        </div>
    </el-drawer>
    <el-dialog v-else :visible="visible" :close-on-click-modal="false" :append-to-body="true" width="450px" @open="initData" @close="onCancel">
        <div class="lock-detail stake">
            <template v-if="!isUnlock">
                <route-tab v-if="lockData.token" :tabs="[]">
                    <div @click="tabIndex = 0" :class="['tab-content-item', tabIndex === 0 ? 'active' : '']">{{ $t('page.lockTimeTab') }}</div>
                    <div @click="tabIndex = 1" :class="['tab-content-item', tabIndex === 1 ? 'active' : '']">{{ $t('page.lockValueTab') }}</div>
                </route-tab>
                <div v-if="(lockData.token && tabIndex === 1) || !lockData.token" class="title">{{ $t('page.lockMsg1') }}</div>
                <div v-if="(lockData.token && tabIndex === 1) || !lockData.token" class="amount">
                    <div class="name">{{ $t('page.GyroBalance') }}: {{ $store.state.account.gyro }}Gyro</div>
                    <el-input :disabled="loading" :placeholder="$store.state.account.gyro" v-model="value"></el-input>
                    <el-button class="max mt" @click="value = $store.state.account.gyro">{{ $t('page.max') }}</el-button>
                </div>
                <div v-if="(lockData.token && tabIndex === 0) || !lockData.token" class="title">{{ $t('page.lockMsg2') }}</div>
                <div v-if="(lockData.token && tabIndex === 0) || !lockData.token" class="amount">
                    <div class="name">{{ $t('page.lockMsg3', {m: maxWeek}) }}</div>
                    <el-input-number v-model="week" controls-position="right" :min="0" :max="maxWeek"></el-input-number>
                    <div class="fast-tag">
                        <div
                            :class="['tag', week == tag.week ? 'active' : '']"
                            @click="setWeek(tag.week)"
                            v-for="(tag, index) in fastTags"
                            :key="index"
                        >
                            {{ tag.label }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="info">
                <div class="item">
                    <p class="label">{{ $t('page.voteValue') }}</p>
                    <p class="value">{{ showVeGyro }} veGYRO</p>
                </div>
                <div class="item">
                    <p class="label">{{ $t('page.voteAmount') }}</p>
                    <p class="value">{{ voteAmount }} GYRO</p>
                </div>
                <div class="item">
                    <p class="label">{{ $t('page.expirationDate') }}</p>
                    <p class="value">{{ showExpirationDate }}</p>
                </div>
            </div>
            <div v-if="isUnlock" class="btns">
                <el-button v-if="isReset" :loading="resetLoading" @click="reset" type="primary" class="btn" round>
                    {{ $t('page.reset') }}
                </el-button>
                <el-button :loading="loading" :disabled="unlockStep && isReset" @click="unlock" type="primary" class="btn" round>
                    {{ $t('page.unlock') }}
                </el-button>
            </div>
            <div v-else class="btns">
                <el-button v-if="!isApprove" type="primary" :loading="approveLoading" class="btn approve" @click="setApprove" round>
                    {{ $t('page.approve') }}
                </el-button>
                <el-button :disabled="isAddLock" :loading="loading" @click="confirmLock" type="primary" class="btn" round>
                    {{ confirmLockName }}
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import RouteTab from '@/components/RouteTab';
import {utils, BigNumber, constants} from 'ethers';
import {GYRO_ADDRESSES} from '@/connectors/config';
import {numberDecimals, formatDate, isMobile} from '@/utils';

export default {
    components: {
        RouteTab
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        lockData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            tabIndex: 0,
            week: 0,
            value: '',
            loading: false,
            approveLoading: false,
            resetLoading: false,
            isApprove: true,
            isLockBtn: true,
            expirationDate: '',
            tagValue: '',
            veGyro: '',
            unlockStep: true,
            isReset: true,
            maxLockLength: 4 * 365 * 86400,
            maxWeek: 208
        };
    },
    computed: {
        isAddLock() {
            if (this.isLockBtn) return true;
            const {lockData, tabIndex, week, value} = this;
            const {token} = lockData;
            if (!token) return false;
            if (token && tabIndex === 0 && week > 0) return false;
            if (token && tabIndex === 1 && value > 0) return false;
            return true;
        },
        fastTags() {
            const tags = [
                {label: this.$t('page.week', {num: 1}), week: 1},
                {label: this.$t('page.month', {num: 1}), week: 4},
                {label: this.$t('page.month', {num: 3}), week: 13},
                {label: this.$t('page.month', {num: 6}), week: 26},
                {label: this.$t('page.year', {num: 1}), week: 52},
                {label: this.$t('page.year', {num: 2}), week: 104},
                {label: this.$t('page.year', {num: 3}), week: 156},
                {label: this.$t('page.year', {num: 4}), week: 208}
            ];
            return tags.filter(tag => tag.week <= this.maxWeek);
        },
        voteAmount() {
            let {value} = this;
            const {voteAmount} = this.lockData;
            value = value ? value : 0;
            return voteAmount ? voteAmount + parseFloat(value) : value;
        },
        showVeGyro() {
            const week = this.lockData.expirationDate
                ? this.getExpirationDate() + this.week
                : this.week + (this.lockData.expirationDate ? 0 : 0.1428);
            let veGyro = ((this.getUtcDateTime(parseInt(week * 7 * 86400000)) - new Date().getTime()) / 1000 / this.maxLockLength) * this.value;
            if (this.lockData.voteValue) veGyro = veGyro + this.lockData.voteValue;
            return numberDecimals(veGyro);
        },
        showExpirationDate() {
            const time = this.getUtcDateTime() + this.calculateWeek() * 7 * 24 * 3600000 + (this.lockData.expirationDate ? 0 : 86400000);
            return time > 0 ? formatDate(new Date(parseInt(time / 7) * 7), 'yyyy-MM-dd') : '-';
        },
        confirmLockName() {
            if (this.getConfirmType() === 1) return this.$t('page.confirmLockTime');
            if (this.getConfirmType() === 2) return this.$t('page.confirmLockValue');
            return this.$t('page.confirmLock');
        },
        isMobile() {
            return isMobile();
        },
        isUnlock() {
            if (!this.lockData.expirationDate) return false;
            const lockEnd = new Date(this.lockData.expirationDate).getTime();
            if (lockEnd <= this.getUtcDateTime()) return true;
            return false;
        }
    },
    watch: {
        '$store.state.wallet.provider': {
            immediate: true,
            handler() {
                this.getApprove();
            }
        }
    },
    methods: {
        addMaxTime() {
            const {expirationDate} = this.lockData;
            if (!expirationDate) return 208;
            const remainder = new Date(this.lockData.expirationDate).getTime() - this.getUtcDateTime();
            return 208 - Math.ceil(remainder / 7 / 86400000);
        },
        setWeek(week) {
            this.week = week;
        },
        getUtcDateTime(timestamp) {
            const day = timestamp ? new Date(new Date().getTime() + timestamp) : new Date();
            day.setHours(0 - day.getTimezoneOffset() / 60, 0, 0, 0);
            return day.getTime();
        },
        async getNFTVoted() {
            const {veGyroContract} = this.$store.state.wallet;
            if (!veGyroContract || !this.lockData.token) return;
            try {
                this.isReset = await veGyroContract.voted(this.lockData.token.toString());
            } catch (error) {
                console.error(error);
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async unlock() {
            const {veGyroContract} = this.$store.state.wallet;
            if (!veGyroContract) return;
            if (this.lockData.lockRewards > 0) {
                const flag = await this.$confirm(
                    this.$t('page.mintRewardContent', {name: this.$t('page.vest')}),
                    this.$t('page.mintRewardTitle')
                ).catch(() => 'cancel');
                if (flag == 'cancel') return;
            }
            try {
                this.loading = true;
                const tx = await veGyroContract.withdraw(this.lockData.token.toString());
                await tx.wait();
                this.loading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
                this.onCancel();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async reset() {
            const {voterContract} = this.$store.state.wallet;
            if (!voterContract) return;
            try {
                this.resetLoading = true;
                const tx = await voterContract.reset(this.lockData.token.toString());
                await tx.wait();
                this.resetLoading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
                this.unlockStep = false;
            } catch (error) {
                console.error(error);
                this.resetLoading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        calculateWeek() {
            if (!this.lockData.expirationDate) return this.week;
            return this.getExpirationDate() + this.week;
        },
        initData() {
            this.getNFTVoted();
            this.maxWeek = this.addMaxTime();
        },
        getConfirmType() {
            if (this.lockData.token && this.tabIndex === 0) return 1;
            if (this.lockData.token && this.tabIndex === 1) return 2;
            return 3;
        },
        getExpirationDate() {
            if (!this.lockData.expirationDate) return 0;
            const lockEnd = new Date(this.lockData.expirationDate).getTime();
            const expirationDate = (lockEnd / 7) * 7 - this.getUtcDateTime();
            return expirationDate / 7 / 24 / 3600000;
        },
        confirmLock() {
            const type = this.getConfirmType();
            if (type === 3) return this.setLock();
            if (type === 1) return this.setLockTime();
            if (type === 2) return this.setLockValue();
        },
        onCancel() {
            this.week = 0;
            this.value = '';
            this.$emit('update:visible', false);
        },
        async setLockTime() {
            if (!this.week) return this.$message.error(this.$t('page.lockDataMsg'));
            const {veGyroContract} = this.$store.state.wallet;
            if (!veGyroContract) return;
            try {
                this.loading = true;
                const lockDuration = parseInt((this.week + this.getExpirationDate()) * 7 * 86400);
                const tx = await veGyroContract.increase_unlock_time(this.lockData.token, utils.parseUnits(lockDuration.toString(), 0));
                await tx.wait();
                this.loading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
                this.onCancel();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async setLockValue() {
            if (!this.value) return;
            if (0 > this.value) return this.$message.error(this.$t('page.lockDataMsg1'));
            const value = typeof this.value === 'number' ? this.value : Number(this.value.replace(/,/g, ''));
            if (value <= 0 || isNaN(value)) return this.$message.error(this.$t('page.greaterThanZero'));
            const {veGyroContract} = this.$store.state.wallet;
            if (!veGyroContract) return;
            try {
                this.loading = true;
                const tx = await veGyroContract.increase_amount(this.lockData.token, utils.parseUnits(value.toString(), 9));
                await tx.wait();
                this.loading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
                this.onCancel();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async setLock() {
            if (!this.value || !this.week) return;
            const value = typeof this.value === 'number' ? this.value : Number(this.value.replace(/,/g, ''));
            if (value <= 0 || isNaN(value)) return this.$message.error(this.$t('page.greaterThanZero'));
            const {veGyroContract} = this.$store.state.wallet;
            if (!veGyroContract) return;
            try {
                this.loading = true;
                const lockDuration = this.week * 7 * 86400 + 86400;
                const tx = await veGyroContract.create_lock(utils.parseUnits(value.toString(), 9), utils.parseUnits(lockDuration.toString(), 0));
                await tx.wait();
                this.loading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
                this.onCancel();
            } catch (error) {
                console.error(error);
                this.loading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async setApprove() {
            const {gyroContract} = this.$store.state.wallet;
            if (!gyroContract) return;
            try {
                this.approveLoading = true;
                const tx = await gyroContract.approve(GYRO_ADDRESSES.veGyro, constants.MaxUint256);
                await tx.wait();
                this.isApprove = true;
                this.isLockBtn = false;
                this.approveLoading = false;
                this.$message.success(this.$t('page.approveSuccess'));
            } catch (error) {
                this.approveLoading = false;
                console.error(error);
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.approveFailed'));
            }
        },
        // Get an authorization
        async getApprove() {
            const {gyroContract, account} = this.$store.state.wallet;
            if (!gyroContract) return;
            this.defaultApproveBtn = false;
            try {
                const isQuota = await gyroContract.allowance(account, GYRO_ADDRESSES.veGyro);
                if (BigNumber.isBigNumber(isQuota) && utils.formatUnits(isQuota, 9) > 0) {
                    this.isLockBtn = false;
                } else {
                    this.isApprove = false;
                }
            } catch (error) {
                console.error(error);
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.getAllowanceFailed'));
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.lock-detail {
    padding: 30px;
    max-width: 480px;
    margin: 0 auto;
    .tab-content .tab-content-item {
        padding: 0 10px;
    }
    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: -0.01em;
        color: #333;
        margin-bottom: 10px;
        margin-top: 20px;
    }
    .info {
        margin: 25px 12px;
        .item {
            display: flex;
            line-height: 17px;
            margin-bottom: 15px;
            .label {
                color: #666;
                font-weight: 600;
                font-size: 14px;
            }
            .value {
                flex: 1;
                color: #444;
                font-weight: 600;
                text-align: right;
                font-size: 14px;
            }
        }
    }
}
.fast-tag {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(4, 22%);
    grid-column-gap: 4%;
    align-items: center;
    grid-row-gap: 10px;
    .tag {
        background-color: #fff;
        font-size: 10px;
        padding: 8px 0;
        border-radius: 20px;
        text-align: center;
        display: block;
        &.active {
            background: #8f84c7;
            color: #fff;
        }
    }
}
</style>
